import React from "react";
import "../../Styles/Components.less";
import PropTypes from "prop-types";
import MainPage from "../MainPage";
import { message } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  EntityStatus,
  NavMenuItems,
  ServiceActions,
} from "../../Constants/Constants";
import ListService from "./ListService";
import ServiceForm from "./ServiceForm";
import ServiceDependency from "./ServiceDependency";
import ServiceInstance from "../ServiceInstance/ServiceInstance";
import { convertServiceList } from "../../Helpers/ServiceHelpers";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.service.icon()}
        <span>{NavMenuItems.service.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      serviceData: null,
      serviceDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateServiceList();
  }

  updateServiceList() {
    const { history, serviceApi } = this.props;
    this.setState({ serviceDataLoading: true });
    const errorCallback = () => {
      this.setState({ serviceDataLoading: false });
      message.error("Error fetching Service list");
    };
    const successCallback = (data) => {
      const serviceData = convertServiceList(data);
      console.log("updateServiceList data", serviceData);
      this.setState({ serviceData, serviceDataLoading: false });
    };
    try {
      serviceApi.getService(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      const { serviceApi } = this.props;
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record.serviceId, !status),
      });
      if (status) {
        serviceApi.activateService(record.serviceId, callback);
      } else {
        serviceApi.inActivateService(record.serviceId, callback);
      }
      this.changeStatus(record.serviceId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  changeStatus = (serviceId, status) => {
    const serviceData = [...this.state.serviceData];
    serviceData.forEach((obj) => {
      if (obj.serviceId === serviceId) {
        obj.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
      }
    });
    this.setState({ serviceData });
  };

  render() {
    const { action, record, serviceData, serviceDataLoading } = this.state;
    return (
      <MainPage>
        <div className="service-container">
          {!action ? (
            <ListService
              serviceData={serviceData}
              serviceDataLoading={serviceDataLoading}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              parentBread={this.header}
            />
          ) : action === ServiceActions.dependency ? (
            <ServiceDependency
              record={record}
              serviceData={serviceData}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceActions.instance ? (
            <ServiceInstance
              record={record}
              serviceData={serviceData}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : (
            <ServiceForm
              action={action}
              record={record}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceApi: state.apis.serviceApi,
});

const connectedService = connect(mapStateToProps)(Service);

Service.propTypes = {
  serviceApi: PropTypes.object,
};

export default withRouter(connectedService);
